import { pick, keys, merge } from 'lodash';

export class PayloadBase {
  static new(model: ModelLike) {
    const instance = new this();
    console.log(instance);
    return instance;
  }

  static fill<T>(instance: T, object: any) {
    object = object || {};
    const props = pick(object, keys(instance));
    merge(instance, props);
    return instance;
  }
}

export type ModelLike = {
  [key: string]: any
}
